export default __webpack_public_path__ + "static/media/Boardkey.3b0d214f.jpg";